const MaterialsPanel = ({
  showMaterialsPanel,
  materialsPanelCollapsed,
  setMaterialsPanelCollapsed,
  children,
}) => {
  if (!showMaterialsPanel) return null;

  return (
    <div className="flex shrink-0 min-h-0 items-stretch">
      <button
        type="button"
        onClick={() => setMaterialsPanelCollapsed((v) => !v)}
        className="flex w-6 h-12 shrink-0 flex-col items-center justify-center self-center rounded-l-lg transition-colors bg-white/35 box-border backdrop-blur-xl backdrop-saturate-150 border-r border-gray-200/60"
        title={materialsPanelCollapsed ? 'Show materials panel' : 'Hide materials panel'}
        aria-expanded={!materialsPanelCollapsed}
        aria-label={materialsPanelCollapsed ? 'Show materials panel' : 'Hide materials panel'}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`shrink-0 transition-transform duration-300 ease-out ${materialsPanelCollapsed ? '' : 'rotate-180'}`}
          aria-hidden
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>
      <aside
        className={`shrink-0 min-h-0 overflow-hidden transition-[width] duration-300 ease-in-out motion-reduce:transition-none ${
          materialsPanelCollapsed ? 'w-0 pointer-events-none' : 'w-[16rem]'
        }`}
        aria-label="Materials"
      >
        <div className="flex h-full min-h-0 w-[16] min-w-[16rem] flex-col gap-4 border-l border-gray-200 border-white/50 bg-white/35 py-4 px-2 box-border backdrop-blur-xl backdrop-saturate-150">
          {children}
        </div>
      </aside>
    </div>
  );
};

export default MaterialsPanel;
